import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { setFilesPartsEmpty } from "../slice/searchPaginationSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
const data = [
  {
    Compartment_data: {
      roll_no: "1234567890",
      bseb_unique_id: "1234567890",
    },
    total_number_records: 10,
    status: "pending",
    id: 1,
  },
];

const getStatusChip = (status) => {
  switch (status) {
    case "pending":
      return <Chip label="Pending" color="warning" />;
    case "success":
      return <Chip label="Success" color="success" />;
    case "Failed":
      return <Chip label="Failed" color="error" />;
    default:
      return <Chip label="Unknown" />;
  }
};
const ReportView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { details } = location?.state || "";
  console.log(details, "details");
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="../full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        <Box gap="10px" alignItems="center" mb={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{ marginBottom: "10px", width: "91%" }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
              }}
            >
              Report Details
            </Typography>
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            gap={2}
            mb={2}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate(-1);
              }}
              style={{ textTransform: "none" }}
            >
              Back to Dashboard
            </Button>

            {/* <Button
              variant="contained"
              color="primary"
              style={{ textTransform: "none", marginLeft: "auto" }}
            >
              Refresh
            </Button> */}
          </Box>
          <Stack spacing={2}>
            <Paper key={1} elevation={3} sx={{ p: 2, borderRadius: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Box sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                      Time
                    </Typography>
                    <Typography>
                      {details?.createdAt
                        ? new Date(details?.createdAt).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                          })
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                      Transaction ID
                    </Typography>
                    <Typography>{details?.transactionId}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                      Price
                    </Typography>
                    <Typography>{details?.amount}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                      School Code
                    </Typography>
                    <Typography>{details?.schoolCode}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                      Status
                    </Typography>
                    {getStatusChip(details?.transactionStatus)}
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Stack>
        </Box>
      </Container>
    </>
  );
};
export default ReportView;
